import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const Invite = ({
  eyebrow = "Start a brief",
  title = "Send us a brand on the move.",
  text = "Tell us what you want to change. We respond within one business day with a candid take — including referring you elsewhere if we are not the fit."
}) => (
  <section className="invite">
    <div className="shell">
      <div className="layout">
        <div>
          <span className="eyebrow eyebrow--light">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="actions">
          <Link to="/contact" className="btn btn--cobalt">
            Start a brief <FiArrowRight />
          </Link>
          <Link to="/capabilities" className="btn btn--ghost-light">All capabilities</Link>
        </div>
      </div>
    </div>
  </section>
);

export default Invite;
